export interface IBlobFileUploadResponse {
	CreatedOn: string;
	Id: string;
	OriginalFileName: string;
	Size: number;
	Status: number;
	StatusDescription: string;
	UpdatedOn: string;
	Url: string;
	UserId: string;
}
